// extracted by mini-css-extract-plugin
export default {"tabsContainer":"Metrics_tabsContainer__Ok602","tabsInner":"Metrics_tabsInner__eB07j","tabItem":"Metrics_tabItem__co+ag"};